/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
/**
 * @license
 * 
 * This bundle contains the following third-party dependencies:
 * 
 * tslib:
 * 
 ****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
*****************************************************************************
 * 
 * flatpickr:
 * 
 *****************************************************************************
	    Copyright (c) Microsoft Corporation.

	    Permission to use, copy, modify, and/or distribute this software for any
	    purpose with or without fee is hereby granted.

	    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	    PERFORMANCE OF THIS SOFTWARE.
	    *****************************************************************************
 * 
 * @carbon/motion:
 * 
 * Copyright IBM Corp. 2018, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 * @carbon/layout:
 * 
 * Copyright IBM Corp. 2018, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 * lit-html:
 * 
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 * 
 * lit-element:
 * 
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 * 
 * @lit/reactive-element:
 * 
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 * 
 * Also refer to the following links for the license of other third-party dependencies:
 * 
 * https://www.npmjs.com/package/lit
 * https://www.npmjs.com/package/lodash-es
 * https://www.npmjs.com/package/@floating-ui/dom
 * https://www.npmjs.com/package/@floating-ui/utils
 * https://www.npmjs.com/package/@floating-ui/core
 */

import{_ as t,r as e,x as s,p as o}from"./settings-9076e2f1.js";import{B as n}from"./defs-6e0d1f36.js";import{b as a,C as l}from"./button-85e3131f.js";import{c as r}from"./carbon-element-017b212d.js";import{e as i}from"./class-map-697ef015.js";import{o as d}from"./if-defined-fe856083.js";
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */let c=class extends e{render(){return s`<slot></slot>`}connectedCallback(){super.connectedCallback(),this.setAttribute("role","list")}};c.styles=a,c=t([r(`${o}-button-set-base`)],c);var b=c;
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */let u=class extends b{_handleSlotChange(t){t.target.assignedNodes().filter((t=>void 0!==t.matches&&t.matches(this.constructor.selectorItem))).forEach(((t,e)=>{t.setAttribute("kind",0===e?n.SECONDARY:n.PRIMARY)}));const e=new CustomEvent(`${o}-btn-set-update`,{bubbles:!0,cancelable:!0,composed:!0});this.dispatchEvent(e)}render(){return s` <slot @slotchange="${this._handleSlotChange}"></slot> `}static get selectorItem(){return`${o}-button`}};u.shadowRootOptions=Object.assign(Object.assign({},e.shadowRootOptions),{delegatesFocus:!0}),u.styles=a,u=t([r(`${o}-button-set`)],u);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
let h=class extends l{_handleClickLinkSkeleton(t){this.disabled&&(t.preventDefault(),t.stopPropagation())}render(){const{autofocus:t,disabled:e,download:n,href:a,hreflang:l,ping:r,rel:c,size:b,target:u,type:h}=this,$=i({[`${o}--btn`]:!0,[`${o}--skeleton`]:!0,[`${o}--btn--${b}`]:b,[`${o}--layout--size-${b}`]:b});return a?s`
          <a
            id="button"
            role="button"
            class="${$}"
            download="${d(n)}"
            href="${d(a)}"
            hreflang="${d(l)}"
            ping="${d(r)}"
            rel="${d(c)}"
            target="${d(u)}"
            type="${d(h)}"
            @click="${this._handleClickLinkSkeleton}"></a>
        `:s`
          <button
            id="button"
            class="${$}"
            ?autofocus="${t}"
            ?disabled="${e}"
            type="${d(h)}"></button>
        `}};h.shadowRootOptions=Object.assign(Object.assign({},e.shadowRootOptions),{delegatesFocus:!0}),h.styles=a,h=t([r(`${o}-button-skeleton`)],h);
